import { Action } from 'redux';
import { getType } from 'typesafe-actions';
import { AppState } from '../app-state';
import {
  appendAnnotationRelations,
  createAnnotationRelation,
  deleteAnnotationChildRelations,
  deleteAnnotationRelation,
  replaceAnnotationRelations,
} from './actions/annotation-relations.actions';
import {
  appendAnnotations,
  createAnnotation,
  deleteAnnotation,
  deleteAnnotations,
  replaceAnnotations,
  splitAnnotation,
  updateAnnotationTypes,
  updateAnnotationValues,
} from './actions/annotations.actions';
import { selectAnnotations } from './selectors/annotation.selectors';

/**
 * Create an "undo" action for a particular store action.
 * @param action The action being fired.
 * @param previousState The state before reducers have run the action.
 * @param postState The state after reducers have run the action.
 */
export function createUndoAnnotationActions(
  action: Action & any,
  previousState: AppState,
  postState: AppState,
): (Action & any)[] {
  switch (action.type) {
    case getType(appendAnnotations):
    case getType(appendAnnotationRelations):
    case getType(deleteAnnotation):
    case getType(deleteAnnotations):
    case getType(createAnnotation):
    case getType(updateAnnotationValues):
    case getType(updateAnnotationTypes):
    case getType(createAnnotationRelation):
    case getType(deleteAnnotationRelation):
    case getType(deleteAnnotationChildRelations):
    case getType(splitAnnotation): {
      const prevAnnotations = selectAnnotations(previousState);
      const prevRelations = previousState.annotationRelations.entities;
      return [
        replaceAnnotations(
          prevAnnotations,
          previousState.annotations.sourceDocumentId,
        ),
        replaceAnnotationRelations(prevRelations),
      ];
    }

    default: {
      return [];
    }
  }
}

/**
 * Create a "redo" action for a particular store action.
 * @param action The action being fired.
 * @param previousState The state before reducers have run the action.
 * @param postState The state after reducers have run the action.
 */
export function createRedoAnnotationActions(
  action: Action & any,
  previousState: AppState,
  postState: AppState,
): (Action & any)[] {
  switch (action.type) {
    case getType(appendAnnotations):
    case getType(appendAnnotationRelations):
    case getType(deleteAnnotation):
    case getType(deleteAnnotations):
    case getType(createAnnotation):
    case getType(updateAnnotationValues):
    case getType(updateAnnotationTypes):
    case getType(createAnnotationRelation):
    case getType(deleteAnnotationRelation):
    case getType(deleteAnnotationChildRelations):
    case getType(splitAnnotation): {
      const newAnnotations = selectAnnotations(postState);
      const newRelations = postState.annotationRelations.entities;
      return [
        replaceAnnotationRelations(newRelations),
        replaceAnnotations(
          newAnnotations,
          postState.annotations.sourceDocumentId,
        ),
      ];
    }

    default: {
      return [];
    }
  }
}
